import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../../images/case-studies/soundly/client_expectations.webp";
function Clients() {
  return (
    <div
      className="client_expectations p-100 case_soundly"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="ms-auto my-auto">
            <h2>
              <span>Client’s  </span>Expectations
            </h2>
            <p>
              The client wanted a platform that could unlock the true experience
              of music through modern technologies by ensuring the delivery of
              an even more immersive listening experience than what is currently
              available in the market.
            </p>
            <p>
              The idea was based not only on building a revolutionary
              entertainment app but also on ensuring predictive, user-friendly,
              and seamless navigation and controls that would let the users
              instantly tap their way to their favorite songs coming directly
              from new artists or upload their songs.
            </p>
            <p>
              The Tekrevol team was chosen to build the app's design and
              functionality from scratch.
            </p>
            <p>
              In the fewest possible words, here's what the client wanted in his
              mobile application:
            </p>
            <ul>
              <li>
                A clean and interactive UI/UX that reflects music from the
                moment the user opens the app.
              </li>
              <li>
                Easy and minimalist representation of options,
                navigation,screens, and more.
              </li>
              <li>
                Features such as an equalizer, profile and playlist creation,
                sound recommendations based on preference, and more were
                integrated.
              </li>
              <li>
                Online payment functionality integration for effective
                processing of donations.
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Clients;
